import * as React from 'react'
import {IMapService} from '../../core/interfaces/services'

interface Props {
  style?: React.CSSProperties
  imgSrc: string
  content: JSX.Element
  title: JSX.Element
  imgHeight: string
  verticalSpeed: string
  horizontalSpeed: string
  right?: boolean
  onExpandChanged?: (expanded: boolean) => void
  expanded?: boolean
  hide?: boolean
  mapService?: IMapService
}

interface State {
  expanded: boolean
}

export class OnMapWidget extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      expanded: false
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({...this.state, expanded: true})
    }, 600)
  }
  render() {
    const maxH = this.props.mapService ? `${this.props.mapService.getHeight() - 100}px` : '900px'
    const maxW = this.props.mapService ? `${this.props.mapService.getWidth() - 40}px` : '400px'
    const expded = this.props.onExpandChanged ? !!this.props.expanded : this.state.expanded
    return (
      <div
        className="on-map-widget"
        style={{
          display: this.props.hide ? 'none' : '',
          left: this.props.right ? '' : '20px',
          right: this.props.right ? '20px' : '',
          maxHeight: expded ? maxH : this.props.imgHeight,
          minHeight: this.props.imgHeight,
          minWidth: this.props.imgHeight,
          zIndex: expded ? 6 : 5,
          transition: expded
            ? `max-height ${this.props.verticalSpeed} ease ${this.props.horizontalSpeed}`
            : `max-height ${this.props.verticalSpeed} ease`,
          ...this.props.style
        }}
      >
        <img
          alt=""
          onClick={() =>
            this.props.onExpandChanged
              ? this.props.onExpandChanged(!expded)
              : this.setState({...this.state, expanded: !expded})
          }
          src={this.props.imgSrc}
          style={{
            cursor: 'pointer',
            position: 'absolute'
          }}
        ></img>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: expded ? this.props.imgHeight : '0px',
            maxHeight: expded ? maxH : '0px',
            maxWidth: expded ? '400px' : '0px',
            width: maxW,
            overflow: 'hidden',
            transition: expded
              ? `max-height ${this.props.verticalSpeed} ease ${this.props.horizontalSpeed}, max-width ${this.props.horizontalSpeed} ease`
              : `max-height ${this.props.verticalSpeed} ease, max-width ${this.props.horizontalSpeed} ease ${this.props.verticalSpeed}`
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              minHeight: this.props.imgHeight,
              fontSize: '16px',
              paddingLeft: '66px',
              paddingRight: '15px',
              alignItems: 'center'
            }}
          >
            <div>{this.props.title}</div>
            <img
              alt=""
              src="resources/icons/close.png"
              style={{cursor: 'pointer', marginLeft: '20px'}}
              onClick={() =>
                this.props.onExpandChanged
                  ? this.props.onExpandChanged(!expded)
                  : this.setState({...this.state, expanded: !expded})
              }
            ></img>
          </div>
          <div
            style={{
              overflow: 'auto',
              height: '100%'
            }}
          >
            {this.props.content}
          </div>
        </div>
      </div>
    )
  }
}
